export const PAYMENT_GATEWAYS = [
  { value: "All", label: "All" },
  { value: "Razorpay", label: "Razorpay" },
  { value: "Stripe", label: "Stripe" },
  { value: "In App Purchase", label: "In App Purchase" },
  { value: "FlutterWave", label: "FlutterWave" },
  { value: "PayPal", label: "PayPal" },
  { value: "PayStack", label: "PayStack" },
  { value: "CashFree", label: "CashFree" },
];

